// ASSETS
import '../../assets/styles/toolHeader.css';
import { FaUpload, FaFileExport, FaExclamationTriangle, FaClipboardList, FaStoreAlt } from "react-icons/fa";

export default function ToolHeader(props) {
    return (
        <div className="tool_header d-flex justify-content-center align-items-center">
            <div className="tool_title">
                {props.icon === "upload" ?
                    <FaUpload className="tool_icon text-info me-2" /> :
                    null
                }
                {props.icon === "export" ?
                    <FaFileExport className="tool_icon text-success me-2" /> :
                    null
                }
                {props.icon === "products" ?
                    <FaClipboardList className="tool_icon text-primary me-2" /> :
                    null
                }
                {props.icon === "shop" ?
                    <FaStoreAlt className="tool_icon text-muted me-2" /> :
                    null
                }
                {props.icon === "conflicts" ?
                    <FaExclamationTriangle className="tool_icon text-danger me-2" /> :
                    null
                }

                <span>{props.toolHeader}</span>
            </div>
        </div>
    );
}
